import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const UsageQuotasPage = lazy(() => import('./UsageQuotasPage'))

class UsageQuotasPageWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['team-uuid']
  }

  override render() {
    return (
      <PageRoot>
        <UsageQuotasPage teamUuid={this.prop('team-uuid')} />
      </PageRoot>
    )
  }
}

customElements.define('usage-quotas-page', UsageQuotasPageWebComponent)
